// eslint-disable-next-line no-unused-vars
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  callAPIHelperV2,
  getClonedDefaultSettingsV2,
  getSelectedRowsV2,
  resetTableDataV2,
  updatedTableDataForPreferenceV2,
  callFxgApi,
} from 'axp-fx-common';
import { actionTableProp } from './actionsInitData';
import { apiPaths } from '../../../constants/paths';
// eslint-disable-next-line no-unused-vars
import EnhancedDataTableWrapper from '../../Common/EnhancedDataTableWrapper';

const defaultTableSettings = getClonedDefaultSettingsV2(actionTableProp);

const ActionsTable = ({ setStepNo, filterData, setSelectedAction }) => {
  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );
  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  const [tableData, setTableData] = useState(actionTableProp);

  const fetchTableData = async () => {
    let newRows = {
      totalRows: 0,
      data: [],
    };
    const reqData = {
      ...filterData,
      emailId: loginData?.email,
    };
    const { response, hasErrors } = await callFxgApi(
      `${fxgApiHost}${apiPaths.userActions}`,
      'POST',
      reqData
    );

    if (!hasErrors) {
      /* istanbul ignore else */
      if (response?.data?.length > 0) {
        const rowData = [];
        response.data.forEach((row) => {
          const rowMap = {
            ...row,
            parsedReqId: `REQ${row.reqId}`,
            rowId: `${row.reqId}_${row.environment}`,
          };
          rowMap.selected = false;
          rowData.push(rowMap);
        });
        newRows = {
          totalRows: response.data.length,
          data: rowData,
        };
      }
    }
    return {
      newRows,
      hasErrors,
    };
  };

  // load table data whenever search is performed
  const loadTableData = useCallback(
    async (updatedTableData) => {
      const { newRows, isError } = await fetchTableData(updatedTableData);
      callAPIHelperV2(updatedTableData, newRows, setTableData, isError);
    },
    [filterData] // fetchTableData is stable
  );

    // Handle fxAccount activation button click
    const activateFxAccount = (row) => {
      setSelectedAction(row);
      setStepNo(2);
    };

  useEffect(() => {
    if (loginData?.userDetail?.emailAddress) {
      updatedTableDataForPreferenceV2(tableData, loginData);
      resetTableDataV2(tableData);
      tableData.expandableComponentProps = { activateFxAccount };
      loadTableData(tableData);
    }
  }, [loadTableData, loginData]); // mutable refs

  // handle appropriate action on selection from inline menu
  const onActionItemClick = (actionId) => {
    const selectedRow = getSelectedRowsV2(tableData)?.[0];
    if (!selectedRow) return;
    if (actionId === 'activate_fxAccount') {
      activateFxAccount(selectedRow);
    }
  };

  return (
    <EnhancedDataTableWrapper
      tableData={tableData}
      setTableData={setTableData}
      fetchTableData={fetchTableData}
      onItemActionClick={onActionItemClick}
      defaultTableSettings={defaultTableSettings}
    />
  );
};

ActionsTable.propTypes = {
  filterData: PropTypes.shape({}),
  setStepNo: PropTypes.func.isRequired,
  setSelectedAction: PropTypes.func.isRequired,
};

ActionsTable.displayName = 'ActionsTable';

export default ActionsTable;
